import { ref, watch } from 'vue'
import ApiService from '@/services/api.js'

export function useProjects(locale) {
  // Reactive state
  const featuredProjects = ref([])
  const imageCache = new Map()
  const loadingImages = new Set()
  const failedImages = new Set()
  
  // Default images for fallbacks
  const defaultImages = {
    project: 'https://images.unsplash.com/photo-1497440001374-f26997328c1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    placeholder: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }

  // Projects yükleme
  const loadProjects = async () => {
    try {
      console.log('🔄 Loading featured projects...')
      const projectsResponse = await ApiService.getProjects({ featured: 'true', limit: 6 })
      console.log('🏗️ Featured projects API response:', projectsResponse)
      
      // API response obje yapısını kontrol et
      let projectsArray = []
      if (projectsResponse && projectsResponse.data && Array.isArray(projectsResponse.data)) {
        projectsArray = projectsResponse.data
      } else if (Array.isArray(projectsResponse)) {
        projectsArray = projectsResponse
      } else if (projectsResponse && projectsResponse.length > 0) {
        projectsArray = projectsResponse
      }
      
      console.log('📋 Extracted projects array:', projectsArray.length, 'projects')
      
      if (projectsArray && projectsArray.length > 0) {
        // API'den zaten sadece featured projeler geliyor, direkt map et
        featuredProjects.value = projectsArray.map(project => ({
          id: project.id,
          title: locale?.value === 'tr' ? (project.title_tr || project.title) : (project.title_en || project.title) || 'Proje',
          description: locale?.value === 'tr' ? (project.description_tr || project.description) : (project.description_en || project.description) || 'Proje açıklaması',
          image: project.image || project.image_url || defaultImages.project,
          capacity: project.capacity,
          location: locale?.value === 'tr' ? (project.location_tr || project.location) : (project.location_en || project.location)
        }))
        console.log('✅ Featured projects loaded:', featuredProjects.value.length, 'projects')
      } else {
        console.warn('⚠️ No projects data received, using fallback')
        setFallbackProjects()
      }
    } catch (error) {
      console.error('❌ Projeler yüklenemedi:', error)
      setFallbackProjects()
    }
  }

  // Fallback projects
  const setFallbackProjects = () => {
    featuredProjects.value = [
      {
        id: 1,
        title: locale?.value === 'tr' ? 'Güneş Enerjisi Projesi' : 'Solar Energy Project',
        description: locale?.value === 'tr' ? 'Büyük ölçekli güneş enerjisi santrali' : 'Large-scale solar power plant',
        image: defaultImages.project,
        capacity: '50 MW',
        location: locale?.value === 'tr' ? 'Ankara' : 'Ankara'
      },
      {
        id: 2,
        title: locale?.value === 'tr' ? 'Rüzgar Enerjisi Projesi' : 'Wind Energy Project',
        description: locale?.value === 'tr' ? 'Rüzgar türbini parkı' : 'Wind turbine park',
        image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        capacity: '30 MW',
        location: locale?.value === 'tr' ? 'İzmir' : 'Izmir'
      }
    ]
  }

  // Image error handling
  const handleImageError = (event, imageType = 'project') => {
    const originalSrc = event.target.src
    failedImages.add(originalSrc)
    loadingImages.delete(originalSrc)
    
    const fallbackUrl = defaultImages[imageType] || defaultImages.placeholder
    if (event.target.src !== fallbackUrl) {
      event.target.src = fallbackUrl
      console.log(`🔄 Fallback image set for ${imageType}:`, fallbackUrl)
    }
  }

  // Navigation
  const goToProjectDetail = (projectId) => {
    window.location.href = `?page=project&id=${projectId}`
  }

  const goToAllProjects = () => {
    console.log('🔍 Navigating to all projects page')
    window.location.href = '?page=projects'
  }

  // Watch locale changes
  if (locale) {
    watch(locale, () => {
      loadProjects()
    })
  }

  // Initialize
  loadProjects()

  return {
    featuredProjects,
    imageCache,
    loadingImages,
    handleImageError,
    goToProjectDetail,
    goToAllProjects,
    loadProjects
  }
}